<!--
 * @Description: 
 * @Author: 王佳兴
 * @Github: 
 * @Date: 2018-12-21 17:02:06
 * @LastEditors: 王佳兴
 * @LastEditTime: 2019-01-03 17:03:30
 -->
<template>
<!--<div style="padding: 0 .4rem" class="box">-->
<!--<tab class="classify_tab" active-color="#fff">-->
<!--<tab-item class="item"  v-for="(item,index) in tabDefault" :key="item.id" > {{item.name}}</tab-item>-->
<!--</tab>-->
<!--</div>-->
<div style="position: relative;" @touchmove.prevent>
  <ul class="first" v-if="!showMore" @touchmove.prevent>
    <li v-for="(item,index) in tabDefault " :key="item.id" :class="[tabIndex == index?'selected':'', 'list']" @click="tabClick(item,index)">
      {{item.categoryName || item.category_name}}

    </li>
    <li class="more" @click="showMore=!showMore">
      <img src="http://cdn.yxvzb.com/newWechat/image/%E5%AD%A6%E7%A7%91-%E5%88%86%E7%B1%BB%E5%B1%95%E5%BC%80@2x.png" alt="">
    </li>
  </ul>

    <div class="moreClass" v-else>
      <p class="top">
        <span>全部学科</span>
        <img class="closeMore" @click="showMore=!showMore" src="http://cdn.yxvzb.com/newWechat/image/%E5%AD%A6%E7%A7%91-%E5%88%86%E7%B1%BB%E5%85%B3%E9%97%AD@2x.png" alt="">
      </p>
      <ul>
        <li v-for="(item, index) in categoryList" :key="index" @click="addClass(item)">
          <img :src="item.picUrl || item.pic_url" alt="">
          <span>{{item.categoryName || item.category_name}}</span>
        </li>
      </ul>
    </div>
  </div>
</div>
</template>
<script>
//  import { Tab, TabItem } from 'vux'
import {
  mapActions,
  mapState
} from 'vuex'
export default {
  name: '',
  props: {
    categoryList: {
      type: Array,
      default: function() {
        return []
      }
    },
    type: {
      type: Number,
      default: 1 // 1 课程 2 专区 3 超级面对面
    }
  },
  data() {
    return {
      tabDefault: [{
        category_name: '全部',
        id: ''
      }],
      tabIndex: 0,
      showMore: false
    }
  },

  methods: {
    ...mapActions([
      'classify'
    ]),
    scFunc(classifyName) {
      let wxUserInfoObj = this.$api.getStorage('wxUserInfo')
      if (this.type == 1) {
        sa.track('wx_load_video_list', {
          title: '直接加载视频页',
          type: classifyName || '全部',
          client_id: wxUserInfoObj.id || wxUserInfoObj.wxOpenId,
          web_edition: 2
        });
      } else if (this.type == 2) {

      } else if (this.type == 3) {

      }
    },

    tabClick(item, index) {
      this.classify(item)
      this.tabIndex = index

      this.scFunc(item.categoryName)
    },
    moreClick() {

    },
    /*
     * 向导航添加  如果匹配ID 如果存在直接选中 如果不存在则添加
     * */
    addClass(item, needShowMore = true) {
      this.scFunc(item.categoryName)
      let add = true
      this.tabDefault.filter((filterItem, index) => {
        if (filterItem.id == item.id) {
          add = false
          this.tabIndex = index
        }
      })
      if (add) {
        this.tabDefault.splice(1, 0, item) //指定插入
        this.tabIndex = 1
        this.tabDefault.pop() //最后一个移除
      }
      this.classify(item)
      if (needShowMore) {
        this.showMore = !this.showMore

      }
    }
  },
  computed: {
    ...mapState({
      classifyId: state => state.classifyId
    })
  },
  watch: {
    categoryList(val) {
      val.filter((item, index) => {
        if (index <= 2) {
          this.tabDefault.push(item)

        }
      })
      if (this.classifyId.id) {
        this.addClass(this.classifyId, false)
      }
    }
  },
  components: {
    //          Tab, TabItem
  },
  created() {

  }
}
</script>
<!--<style lang="less" >-->
<!--.classify_tab{-->
<!--height: .64rem !important;-->
<!--width:80%;-->
<!--background: #F3F3F3;-->
<!--.vux-tab-ink-bar{-->

<!--background-image: linear-gradient(-90deg,#027CFA  0%,#2EACFD  100%);-->
<!--border-radius: .1rem;-->
<!--height: .64rem !important;-->
<!--width:1.6rem !important;-->
<!--top:0 !important;-->

<!--}-->
<!--.vux-tab-item{-->

<!--position: relative;-->
<!--z-index: 100;-->
<!--line-height: 1.9 !important;-->
<!--left:-.15rem;-->
<!--/*flex:none !important;*/-->
<!--}-->
<!--}-->

<!--</style>-->
<style lang="less" scoped>
.first {
    display: flex;
    background: #F3F3F3;
    padding: 0.2133rem 0.4rem;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0.2666rem;
    .list {
        font-size: 0.3733rem;
        background: #fff;
        padding: 0.02rem 0;
        border-radius: 0.08rem;
        text-align: center;
        height: 0.64rem;
        overflow: hidden;
        width: 1.8rem
    }
    .more {
        height: 0.64rem;
        width: 0.64rem;
    }
    .selected {
        background-image: linear-gradient(-90deg, #027CFA 0%, #2EACFD 100%);
        border-radius: 6px;
        color: #fff;
    }
}

.moreClass {
    position: fixed;
    /* top: 0; */
    /* padding: .2rem .4rem; */
    /*background: rgba(255,255,255,.95);*/
    width: 100%;
    height: 100%;
    z-index: 5;
    .top {
        padding: 0 0.4rem;
        border-bottom: 1px solid #EBEBEB;
        height: 1.066rem;
        /*line-height: 1.066rem;*/
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-right: 0.42rem;
        background: #fff;
        span {
            font-size: 0.4266rem;
        }
        .closeMore {
            width: 0.55rem;
            height: 0.55rem;
        }
    }
    ul {
        display: flex;
        /*justify-content: space-around;*/
        width: 100%;
        flex-wrap: wrap;
        align-content: flex-start;
        padding-top: 0.6933rem;
        position: fixed;
        height: 100%;
        background: rgba(255,255,255,.94);

        li {
            margin-bottom: 1.14rem;
            width: 25%;
            text-align: center;
        }
        img {
            width: 0.666rem;
            height: 0.666rem;
            display: block;
            margin: auto;
        }
        span {
            display: block;
            text-align: center;
            margin-top: 0.1rem;
            font-size: 0.266rem;
        }
    }
}
</style>
